{
	"title": "Kenmerken van afgevangen CO\u2082",
	"buttonTitle": "CO\u2082-afvang en -opslag",
	"table": {
		"materialDescription": "Materiaal",
		"quantity": "Hoeveelheid",
		"productGwpTotal": "Totale product-GWP",
		"bundledCarbonReductions": "Gebundelde CO\u2082-reducties",
		"remainingGwp": "Resterende GWP",
		"epdForPhysicalMaterial": "EPD voor fysiek materiaal",
		"carbonPlantName": "Brevik, Noorwegen"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "is de rechtmatige houder van de gerapporteerde CO\u2082-reducties."
	},
	"modal": {
		"title": "CO\u2082-afvang en -opslag",
		"description": "Carbon Capture and Storage (CCS) is een technologie waarmee de kooldioxide (CO2)-emissies die ontstaan door het calcinatieproces en het gebruik van brandstoffen in de ovenwerking kunnen worden afgevangen. Zo wordt voorkomen dat kooldioxide in de atmosfeer terechtkomt en wordt het permanent ondergronds opgeslagen. De afgevangen CO2 uit de fabriek van Heidelberg Materials in Brevik (Noorwegen) wordt gecomprimeerd en getransporteerd naar een opslaglocatie onder de Noordzee. De installatie in onze Brevik-fabriek zal jaarlijks 400.000 ton CO2 afvangen.",
		"showLink": "Meer informatie over het CO\u2082-afvangproces",
		"buttonClose": "Sluiten"
	},
	"footnote": "1) CO\u2082-reducties compenseren de fasen A1-A3 van de levenscyclusinventaris van cement."
}
